import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    editorButtons: false,
    pageCount: 0,
    ready: false,
    docs: 0
  },
  mutations: {
    hideEditorButtons(state) {
      state.editorButtons = false
    },
    showEditorButtons(state) {
      state.editorButtons = true
    },
    incrementPageCount(state, n) {
      state.pageCount += n
    },
    addDocumentContainer(state) {
      state.docs++
    },
    removeDocumentContainer(state) {
      state.docs--
    }
  }
})



// WEBPACK FOOTER //
// ./src/core/Store.js